// extracted by mini-css-extract-plugin
export default {"cls1":"PostPrompt-cls1__El","cls2":"PostPrompt-cls2_Uxh PostPrompt-cls1__El"};